import React from "react";
import '../home-style/home-style.css';


const RedesBanner: React.FC = () => {
  return (
    <section className="bannertotal redes-banner">
      <header>
        <h2>Nuestras Redes</h2>
        <p>Síguenos</p>
      </header>
    </section>
  );
};

export default RedesBanner;